export const AFFILIATE_URL = "https://umtugxsg.com/click?trvid=55211&clickid={clickid}&Cost={amount}";
export const LAST_UPDATED = "July 2026";
export const AFF_DISCLOSURE = "Affiliate Disclosure: If you sign up through this link, VoiceRanker.ai may earn a commission at no additional cost to you.";
export const AUTHOR = "The VoiceRanker Team";
export const AUTHOR_IMG = "https://images.pexels.com/photos/30468636/pexels-photo-30468636.jpeg";
export const HERO_BG = "https://images.pexels.com/photos/27141312/pexels-photo-27141312.jpeg";
export const ABOUT_IMG = "https://images.pexels.com/photos/4319926/pexels-photo-4319926.jpeg";
